import { css } from "styled-components";

export const breakingpoints = {
  l: 1440,
  m: 1024,
  s: 768,
};

export const isDeviceSize = (size) =>
  !!breakingpoints[size] <= breakingpoints[size];

export const media = Object.keys(breakingpoints).reduce(
  (combined, point) => ({
    ...combined,
    [point]: (...args) => css`
      @media (max-width: ${breakingpoints[point]}px) {
        ${css(...args)};
      }
    `,
  }),
  {}
);
